import Config from './Config';

const Api = {
  getFeedData: async () => {
    const podcastsIds = Config.podcastId.split(',');

    const responseData = await Promise.all(podcastsIds.map(id => fetch(`${process.env.REACT_APP_DATASPAN_API_URL}/podcastfeed/read?podcast=${id}&wtRegion=${Config.wtRegion}`).then(response => response.json())));
    const mergedArray = await responseData.flat(2);
    return mergedArray.sort((a, b) => new Date(b.published) - new Date(a.published));
  },
};

export default Api;
